/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-underscore-dangle */
import React from "react";
import PropTypes from "prop-types";
import { get } from "lodash-es";
import * as moment from "moment";
import classNames from "classnames";
import { format } from "timeago.js";
import { formatDate } from "src/utils/CommonUtils";
import ToggleLinkComponent from "../ToggleLinkComponent";

const TableCell = ({ record, colName, columns, className,onClick }) => {
  let colData = "";
  // is path an array. if yes, then concat
  if (Array.isArray(get(columns, `${colName}.path`))) {
    for (let i = 0; i < get(columns, `${colName}.path`).length; i++) {
      let valuePath = get(columns, `${colName}.path[${i}]`, colName);
      colData = colData + " " + get(record, valuePath, "");
    }
    colData = colData.trim();
  } else {
    let valuePath = get(columns, `${colName}.path`, colName);
    colData = get(record, valuePath, "");
  }

  const dataType = get(columns, `${colName}.type`);
  const dataFormat = get(columns, `${colName}.format`);
  const action = get(columns, `${colName}.action`);
  const styleCalculator = get(columns, `${colName}.styleCalculator`);

  let calculatedStyle = {};
  if (styleCalculator) {
    calculatedStyle = styleCalculator(record) || {};
  }

  if (dataType === Date && colData) {
    if (dataFormat?.toLowerCase() === "timeago") {
      colData = format(moment(colData).format("x"));
    } else {
      colData = formatDate(colData, dataFormat);
    }
  }
  if (typeof colData === "boolean" || dataType === Boolean) {
    if (action) {
      colData = (
        <ToggleLinkComponent
          onChange={(value) => {
            action(value, record);
          }}
          value={colData}
        />
      );
    } else {
      colData = colData ? "Yes" : "No";
    }
  }
  if (dataType === "Decimal") colData = Number(colData).toFixed(2);

  if (onClick) {
    return (
      <td
        key={record._id + colName}
        className={classNames(["text-nowrap", className])}
        style={calculatedStyle}
        onClick={() => onClick(record)}
      >
        <span
          style={{
            color: "blue",
            cursor: "pointer",
            textDecoration: "underline",
          }}
        >
          {colData}
        </span>
      </td>
    );
  }
  return (
    <td
      key={record._id + colName}
      className={classNames(["text-nowrap", className])}
      style={calculatedStyle}
    >
      {colData}
    </td>
  );
};

TableCell.propTypes = {
  columns: PropTypes.object.isRequired,
  colName: PropTypes.string.isRequired,
  record: PropTypes.shape({
    _id: PropTypes.any,
  }).isRequired,
  className: PropTypes.string,
};

TableCell.defaultProps = {
  className: "",
};

export default TableCell;
